import { useQuery } from "@tanstack/react-query";

import { priorityRequestsApi } from "@/api";
import { QueryKey } from "@/query/Query";

import { PriorityRequestFilters } from "../PriorityRequests.types";
import { PRIORITY_REQUESTS_REFETCH_INTERVAL_MS } from "../PriorityRequests.utils";

export function usePriorityRequestsQuery(filters: PriorityRequestFilters) {
  return useQuery({
    queryKey: [QueryKey.PriorityRequests, filters],
    queryFn: () =>
      priorityRequestsApi.getAllPriorityRequests({
        counselorId: filters.counselorId ?? undefined,
        reachability: filters.reachability,
        form: filters.form,
      }),
    refetchInterval: PRIORITY_REQUESTS_REFETCH_INTERVAL_MS,
    placeholderData: (previous) => previous,
  });
}
